interface Props {
  topPx: number
}

export const CurrentTimeLine = ({ topPx }: Props) => (
  <div
    className="absolute left-0 right-0 z-20 pointer-events-none"
    style={{ top: topPx }}
  >
    <div className="relative flex items-center">
      <div className="w-2 h-2 rounded-full bg-red-500 shrink-0 -ml-1 z-10" />
      <div className="flex-1 h-[1.5px] bg-red-500" />
    </div>
  </div>
)
